import { EntityLabel } from "components/Shared/Labels/EntityLabel";
import type React from "react";
import { Link } from "react-router-dom";
import "./BaseEntityCard.css";

type Props = {
  to: string;
  name: string;
  desc?: string;
  img?: any | null;
};

export const BaseEntityCard: React.FC<Props> = ({ to, name, desc, img = null }) => {
  return (
    <Link className="base-entity-card" to={to}>
      <div className="p-15 wrap">
        <EntityLabel imageUrl={img} title={<div className="title text-upper">{name}</div>} />
        {desc && <div className="desc text-upper mt-5">{desc}</div>}
      </div>
    </Link>
  );
};
